export enum BeneficiaryEntityTypeEnum {
  Individual = 1,
  Organization = 2,
  Estate = 3
}
